import React from 'react'
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom'
import { TestCheckoutPage } from './pages/test-checkout'
import { PaymentsPage } from './pages/payments-page'
import { PaymentSuccessPage } from './pages/payment-success'
import { SDKRenderPage } from './pages/sdk-render'

// Layout component
const Layout = ({ children }: { children: React.ReactNode }) => (
  <div className="min-h-screen bg-background">
    <header className="border-b">
      <div className="container mx-auto px-4 py-4">
        <h1 className="text-2xl font-bold">Hosted Payments Page</h1>
      </div>
    </header>
    <main className="container mx-auto px-4 py-8">{children}</main>
  </div>
)

const HomePage = () => (
  <Layout>
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Hosted Payments Page</h1>
        <p className="text-muted-foreground mt-2">Welcome to the Hosted Payments Page application</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <div className="p-6 border rounded-lg">
          <h2 className="text-xl font-semibold mb-2">Payments Page</h2>
          <p className="text-muted-foreground mb-4">The hosted payment page for processing customer payments</p>
          <a
            href="/payments"
            className="inline-flex items-center px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
          >
            Open Payments Page
          </a>
        </div>

        <div className="p-6 border rounded-lg">
          <h2 className="text-xl font-semibold mb-2">Test Checkout</h2>
          <p className="text-muted-foreground mb-4">Tools for testing the payment intent creation API</p>
          <a
            href="/test-checkout"
            className="inline-flex items-center px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
          >
            Open Test Checkout
          </a>
        </div>
      </div>
    </div>
  </Layout>
)

// Create router configuration
const router = createBrowserRouter([
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/test-checkout',
    element: <TestCheckoutPage />,
  },
  {
    path: '/payments',
    element: <PaymentsPage />,
  },
  {
    path: '/success',
    element: <PaymentSuccessPage />,
  },
  {
    path: '/sdk-render',
    element: <SDKRenderPage />,
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
])

// Router component
const AppRouter = () => {
  return <RouterProvider router={router} />
}

export default AppRouter
